import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { AppleProfilePresetEntry, AppleProfilePresetType } from './apple-profile-preset.types';

export type AppleProfilePresetState = EntityState<AppleProfilePresetEntry>;

/**
 * Generates the composite ID for an entity.
 * Used by the EntityAdapter to identify entities.
 * Accepts both full preset entries and add-type entries (which lack `uniqueId`).
 *
 * Format: `${profileType}-${preset.uniqueId ?? preset.id}`
 */
export function selectId(entry: {
  profileType: AppleProfilePresetType;
  preset: { id: string; uniqueId?: string };
}): string {
  return createPresetId(entry.profileType, entry.preset.uniqueId ?? entry.preset.id);
}

/**
 * Helper to construct a preset ID for manual lookups (e.g., in selectors).
 * Also used in selectId().
 */
export function createPresetId(profileType: AppleProfilePresetType, presetId: string): string {
  return `${profileType}-${presetId}`;
}

export const adapter: EntityAdapter<AppleProfilePresetEntry> = createEntityAdapter<AppleProfilePresetEntry>({
  selectId,
});

export const initialState: AppleProfilePresetState = adapter.getInitialState();
